// extracted by mini-css-extract-plugin
export default {"property":"MetadataProperty_property__Kqcxt","content":"MetadataProperty_content__WSo6f"};